import type { FaireProductEntity } from "../../entity_types/product";

export const p_p6warpuptn: FaireProductEntity = {
  token: "p_p6warpuptn",
  type: "product",
  name: "Coconut Vanilla Shampoo & Conditioner Bar Set | Organic, Eco-friendly, Plastic-free",
  brandToken: "b_v44qpcjjza",
  brandName: "Lyness",
  imageUrl:
    "https://cdn.faire.com/fastly/5755ddae85d0342d60169fb51fe80e508f2ee236e9ecb205ea4a8ca3ab68e519.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7771e4ed1fd6bc5ddb10750c63a52df38fe0d8f7218c3c13cf2ac052860fe546.jpeg",
    "https://cdn.faire.com/fastly/9ae939146f5c4128e275f04c073dc89f9d2a16a84f49ffd1228f158b65fd1c63.jpeg",
    "https://cdn.faire.com/fastly/46c6e050e6005bd26dd317a9f1e0bc76ed4149c5db7f800d02378b7aae6e6f71.jpeg",
    "https://cdn.faire.com/fastly/e1d678e13d169ada85c91d341929d6e12c8b7bbaf22cf727ac69932df79444fc.jpeg",
    "https://cdn.faire.com/fastly/5a2d2d79cf4bdff1962231e3993d78353696355fbfe54197b600952c4042fd07.jpeg",
    "https://cdn.faire.com/fastly/e422d29437503e7951a1b8c7978e9ea38ab5737fd5483f5628da5970eefdff78.jpeg",
    "https://cdn.faire.com/fastly/cf7a9bc1166369ecb907dc0a23aa5bc06f4f9271383126457c318814365c9def.jpeg",
    "https://cdn.faire.com/fastly/b3ebdb2d0a1e7eb64ec4f16f6f1805494797e372bb706280be5c5dcfc5e51cde.jpeg",
    "https://cdn.faire.com/fastly/d6a42f8329297aaae45dd75ab899b33feecc00db91b76be446fed6b6185952a8.jpeg",
    "https://cdn.faire.com/fastly/329424bf7bcbde655855c7d2893d5f4a3488677f1c7f24d22759d78c89251750.jpeg",
  ],
  priceDollars: 20.99,
  description:
    "A creamy blend of coconut and vanilla that deeply moisturizes, tames frizz, and helps strengthen brittle hair.\n\n * Gentle & Nourishing Cleanse: Sodium Coco Sulfate, derived from coconuts, creates a foamy lather that washes away buildup without the harshness of SLS. \n * Coconut & Vanilla Nourishment: Coconut oil helps prevent dryness, dandruff, split ends, and breakage while sealing in moisture for smooth, frizz-free hair. Vanilla essential oil calms and soothes the scalp while smoothing the cuticle for enhanced shine and a polished, sleek look. \n * Deep Conditioning Care: Shea Butter, Olive Oil, Jojoba Oil, and Coconut Oil in the conditioner replenish hydration, improve texture, and support long-lasting softness and manageability. \n * Strength & Protection: D-Panthenol, Vitamin C, and Vitamin E strengthen strands, boost resilience, and protect against dryness. \n\n",
  tags: [],
  msrpDollars: 34.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:30.319Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
